import React from 'react';
import { ConfirmModal, useModalContext } from '@fourthwall/components';
import { useOffersDuplicateMutation } from '../../hooks/useOffersDuplicateMutation';
import { useSubscriptionOffers } from '../../modules/Subscriptions';
export const useDuplicateProduct = () => {
    const { open } = useModalContext();
    const { shouldShowLimitsModal, shouldShowUpgradeModal, openSubscriptionOffersLimitModal, openSubscriptionOffersUpgradeModal, } = useSubscriptionOffers();
    const { duplicateOfferMutation } = useOffersDuplicateMutation();
    const openDuplicateProductModal = ({ name, id, onSuccess, onError, }) => {
        if (shouldShowLimitsModal) {
            openSubscriptionOffersLimitModal();
            return;
        }
        if (shouldShowUpgradeModal) {
            openSubscriptionOffersUpgradeModal({
                source: 'duplicate_product',
            });
            return;
        }
        open(ConfirmModal, {
            title: 'Duplicate product',
            confirmLabel: 'Duplicate',
            cancelLabel: 'Cancel',
            text: (React.createElement("p", null,
                "Are you sure you want to duplicate ",
                React.createElement("strong", null, name))),
            onConfirm: () => duplicateOfferMutation.mutate([{ offerId: id }], {
                onSuccess,
                onError,
            }),
        });
    };
    return {
        openDuplicateProductModal,
    };
};
